import {
  LOAD_STRENGTH,
  SHOW_STRENGTH,
  CREATE_STRENGTH,
  UPDATE_STRENGTH,
  DELETE_STRENGTH,
  IMPORT_STRENGTH,
  EXPORT_STRENGTH,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    name: "",
    code: "",
    unit: "ksc.",
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STRENGTH.REQUEST:
    case UPDATE_STRENGTH.REQUEST:
    case DELETE_STRENGTH.REQUEST:
    case IMPORT_STRENGTH.REQUEST:
    case EXPORT_STRENGTH.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case LOAD_STRENGTH.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case SHOW_STRENGTH.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false
      };

    case LOAD_STRENGTH.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_STRENGTH.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_STRENGTH.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_STRENGTH.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_STRENGTH.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true
      };

    case IMPORT_STRENGTH.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_STRENGTH.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_STRENGTH.FAILURE:
    case SHOW_STRENGTH.FAILURE:
    case CREATE_STRENGTH.FAILURE:
    case UPDATE_STRENGTH.FAILURE:
    case DELETE_STRENGTH.FAILURE:
    case IMPORT_STRENGTH.FAILURE:
    case EXPORT_STRENGTH.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false
      };

    default:
      return state;
  }
};
